module.exports = __webpack_public_path__ + "img/approval6.d8b4582a.png";